(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvDialogController', PvDialogController);

    PvDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pv', 'Modelosdeimpresora', 'Comercio'];

    function PvDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pv, Modelosdeimpresora, Comercio) {
        var vm = this;

        vm.pv = entity;
        vm.clear = clear;
        vm.save = save;
        vm.modelosdeimpresoras = Modelosdeimpresora.query();
        vm.comercios = Comercio.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pv.id !== null) {
                Pv.update(vm.pv, onSaveSuccess, onSaveError);
            } else {
                Pv.save(vm.pv, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:pvUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
